import { forwardRef, type Ref, type ReactNode } from 'react';
import type { BaseProps } from '../../theme/index.js';
import { useBaseAttrs, splitBaseProps } from '../../core/_internal/factory.js';
import './Fieldset.css';

export interface FieldsetProps extends BaseProps {
  legend?: ReactNode;
  children?: ReactNode;
  variant?: 'default' | 'filled' | 'unstyled';
}

/** Themed `<fieldset>` with optional `<legend>`. */
export const Fieldset = forwardRef(function Fieldset(
  { legend, children, variant = 'default', ...rest }: FieldsetProps,
  ref: Ref<HTMLFieldSetElement>
): ReactNode {
  const base = useBaseAttrs('rr-fieldset', rest, [`rr-fieldset--${variant}`]);
  const { dom } = splitBaseProps(rest);
  return (
    <fieldset {...dom} ref={ref} {...base.attrs} className={base.className} style={base.style}>
      {legend ? <legend className="rr-fieldset__legend">{legend}</legend> : null}
      <div className="rr-fieldset__body">{children}</div>
    </fieldset>
  );
});
